export default __webpack_public_path__ + "static/toggle-perso-68b36b40aca1498d5a73a642adef8d0f.png";